let Filters = {
    FILTER_TYPE_EQUAL: 'FILTER_TYPE_EQUAL',
    FILTER_TYPE_NOT_EQUAL: 'FILTER_TYPE_NOT_EQUAL',
    FILTER_TYPE_EQUAL_LESS: 'FILTER_TYPE_EQUAL_LESS',
    FILTER_TYPE_EQUAL_MORE: 'FILTER_TYPE_EQUAL_MORE',
    FILTER_TYPE_LESS: 'FILTER_TYPE_LESS',
    FILTER_TYPE_MORE: 'FILTER_TYPE_MORE',
    FILTER_TYPE_LIKE: 'FILTER_TYPE_LIKE',
    FILTER_TYPE_IN_ARRAY: 'FILTER_TYPE_IN_ARRAY',
    FILTER_TYPE_NOT_IN_ARRAY: 'FILTER_TYPE_NOT_IN_ARRAY',
    FILTER_TYPE_ARRAY_HAS_VALUE: 'FILTER_TYPE_ARRAY_HAS_VALUE',
    FILTER_TYPE_RANGE: 'FILTER_TYPE_RANGE',
    FILTER_TYPE_OR_MANY_FIELDS: 'FILTER_TYPE_OR_MANY_FIELDS',
    FILTER_TYPE_ARRAY_HAS_DUPLICATES: 'FILTER_TYPE_ARRAY_HAS_DUPLICATES',
    FILTER_TYPE_ARRAY_HAS_NO_DUPLICATES: 'FILTER_TYPE_ARRAY_HAS_NO_DUPLICATES',
    FILTER_TYPE_CALLBACK: 'FILTER_TYPE_CALLBACK',

    DEFAULT_VALUE_FOR_LINEUPS_COUNT: 1,
    DEFAULT_VALUE_FOR_MIN_EXPOSURE: 0,
    DEFAULT_VALUE_FOR_MAX_EXPOSURE: 100,
    DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN: 0.1,

    DEFAULT_VALUES_OF_LINEUPS_MLB_FILTER: {
        order: {
            0: true,
            1: true,
            2: true,
            3: true,
            4: true,
            5: true,
            6: true,
            7: true,
            8: true,
            9: true,
        },
    },

    DEFAULT_VALUES_OF_LINE_GROUPING_NHL_FILTER: {
        1: true,
        2: true,
        3: true,
        4: true,
    },

    DEFAULT_VALUES_OF_LINEUPS_NHL_FILTER: {
        lineGroups: {
            1: true,
            2: true,
            3: false,
            4: false,
        },
        ppLines: {
            1: true,
            2: false,
        },
    },
};

export default Filters;
